import React, { useState, useEffect } from "react"
import axiosInstance from "../../utils/axiosInstance"
import { API_ENDPOINTS } from "../../constants/config"

function EditSchoolModal({ isOpen, onClose, school, onSchoolUpdated }) {
  const [formData, setFormData] = useState({
    name: "",
    domain: "",
    phone: "",
    email: "",
    website: "",
    description: "",
    foundedYear: "",
    group: "",
    tenantType: "school",
  })
  const [error, setError] = useState("")
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (school && isOpen) {
      setFormData({
        name: school.name || "",
        domain: school.domain || "",
        phone: school.phone || "",
        email: school.email || "",
        website: school.website || "",
        description: school.description || "",
        foundedYear: school.foundedYear || "",
        group: school.group || "",
        tenantType: school.tenantType || "school",
      })
      setError("")
    }
  }, [school, isOpen])

  if (!isOpen || !school) return null

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!school?._id) return

    try {
      setSaving(true)
      setError("")
      const token = localStorage.getItem("token")
      const payload = { ...formData }
      if (typeof payload.foundedYear === "string" && payload.foundedYear !== "") payload.foundedYear = Number(payload.foundedYear) || null
      const res = await axiosInstance.patch(
        API_ENDPOINTS.school(school._id),
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )

      if (res.data?.status === "success" && res.data.data?.school) {
        onSchoolUpdated?.(res.data.data.school)
        onClose()
      } else {
        setError(res.data?.message || "Failed to update customer")
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to update customer")
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-lg">
        <h2 className="text-xl font-bold mb-4 text-center">Edit Customer</h2>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-3">
          <input
            type="text"
            name="name"
            placeholder="Customer Name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <input
            type="text"
            name="domain"
            placeholder="Customer Domain"
            value={formData.domain}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <select
            name="tenantType"
            value={formData.tenantType}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
          >
            <option value="school">School</option>
            <option value="industry">Industry</option>
          </select>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input
              type="text"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <input
            type="text"
            name="website"
            placeholder="Website"
            value={formData.website}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <textarea
            name="description"
            placeholder="Description"
            value={formData.description}
            onChange={handleChange}
            rows={3}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <input
            type="number"
            name="foundedYear"
            placeholder="Founded Year"
            value={formData.foundedYear}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <input
            type="text"
            name="group"
            placeholder="Customer group (e.g. dps) - optional"
            value={formData.group}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <div className="flex space-x-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="w-full bg-gray-200 text-gray-700 py-2 rounded-lg hover:bg-gray-300 transition-colors"
              disabled={saving}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-60"
              disabled={saving}
            >
              {saving ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default EditSchoolModal


